export default {"src":"/_next/static/media/heart.39e6d933.svg","height":100,"width":150};